import { Reducer, Action } from "redux";
import { ITestimonialsState, KnownAction, GET_TESTIMONIALS, LOADER_FOR_TESTIMONIALS, GET_OFFERMESSAGE, GET_PACKAGE_MATRIX } from "./types";

export const reducer: Reducer<ITestimonialsState> = (state: ITestimonialsState | undefined, incomingAction: Action): ITestimonialsState => {
    if (state === undefined) {
        return {
            testimonials: [], isLoadingTestimonials: false, promoBannerText: "", packageMatrix: {}
        };
    }
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case GET_TESTIMONIALS:
            return {
                ...state,
                testimonials: action.testimonials,
            };
        case LOADER_FOR_TESTIMONIALS:
            return {
                ...state,
                isLoadingTestimonials: action.isLoadingTestimonials,
            };
        case GET_OFFERMESSAGE:
            return {
                ...state,
                promoBannerText: action.promoBannerText,
            };
        case GET_PACKAGE_MATRIX:
            return {
                ...state,
                packageMatrix: action.packageMatrix,
            };
            ; default:
            return state;
    }
};
